module.exports = "../images/fishing-on-lake-home.jpg?v=aa7d524";